import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import './Component_TagViewer.scss';
import { ComponentSync, LL_H_C, LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import { VariableWrapper } from '../../../wrappers/index.js';
export class Component_TagViewer extends ComponentSync {
    deriveStateFromProps(nextProps) {
        return {
            tags: VariableWrapper.dbTagsToUI(nextProps.tags || [])
        };
    }
    renderTagGroups = (pair) => {
        return _jsxs(_Fragment, { children: [_jsxs("span", { className: 'field-title', children: [pair.key.label, ":"] }), _jsx("span", { className: 'field-data', children: this.renderTags(pair) })] });
    };
    renderTags = (pair) => {
        if (this.props.horizontal)
            return _jsx(LL_H_C, { className: 'variable-tags', children: pair.value.map(item => _jsx("div", { className: 'variable-tag orange', children: item.label }, item.label)) });
        return _jsx(LL_V_L, { className: 'variable-tags', children: pair.value.map(item => _jsx("div", { className: 'variable-tag orange', children: item.label }, item.label)) });
    };
    render() {
        return this.state.tags.map(pair => {
            return _jsx(LL_V_L, { className: 'field', children: this.renderTagGroups(pair) }, pair.key.label);
        });
    }
}
//# sourceMappingURL=Component_TagViewer.js.map